import { type VariantProps, cva } from 'class-variance-authority';
import { Dispatch, JSX, SetStateAction } from 'react';
import { Icon } from '../../Icon/Icon';
import { IconButton } from '../../IconButton/IconButton';

const topBar = cva(
  'sticky top-0 w-full flex items-center justify-between text-center bg-surface border-b z-40 h-[58px] pr-xxs py-xxs',
);

type TopBarProps = VariantProps<typeof topBar> & {
  sideNavOpen: boolean;
  toggleSideNav: Dispatch<SetStateAction<boolean>>;
  logo: JSX.Element; // this can be a link
};

export const TopBar = ({ sideNavOpen, toggleSideNav, logo }: TopBarProps) => {
  const iconName = sideNavOpen ? 'close' : 'menu';

  return (
    <header role="banner" aria-label="App header" className={topBar()}>
      <div className="absolute">
        <IconButton
          intent="ghost"
          size="small"
          aria-label="Toggle side navigation"
          aria-expanded={!sideNavOpen}
          onClick={() => toggleSideNav((prev) => !prev)}
        >
          <span className="sr-only">
            {sideNavOpen
              ? 'Collapse navigation menu'
              : 'Expand navigation menu'}
          </span>
          <Icon name={iconName} />
        </IconButton>
      </div>
      <div
        className="w-full flex shrink-0 grow justify-center"
        aria-label="App logo"
      >
        {logo}
      </div>
    </header>
  );
};
